import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=4a1770a8&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=4a1770a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1770a8",
  null
  
)

export default component.exports